import { VStack } from "@chakra-ui/react";
import { ScreenWrapper } from "components/screen-wrapper";
import { AgencySettingsPageTitle } from "modules/agency-settings/components/agency-settings-page/agency-settings-page-title";
import { PortalTabs } from "modules/agency-settings/screens/feature-preferences/components/portal-tabs";

export function FeaturePreferenceScreen() {
  return (
    <ScreenWrapper>
      <VStack align={"flex-start"} gap={10}>
        <AgencySettingsPageTitle
          title={"Feature preferences"}
          description={
            "Manage what your clients can access on your Rex Home platforms"
          }
        />
        <PortalTabs />
      </VStack>
    </ScreenWrapper>
  );
}
